import { useMutation } from '@tanstack/react-query';
import useTranslate from '../../Hooks/useTranslate';
import notify from '../../Style-guide/ToastMessage';
import { sendData } from '../fetchers';

export const useSendContactUsMessageMutation = () => {
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('contact-us', data, params, queryParams),
    onSuccess: (data) => {
      notify.success(tr(data?.translationKey) || data?.message);
    },
  });
};
